module.exports = __webpack_public_path__ + "img/merry_go_round_at_playground.3b3075ba.jpg";